export const decodeBase64 = (data) => {
  return JSON.parse(atob(decodeURIComponent(data)));
};
